import React from 'react';

import { ThemeProvider } from '@mui/material/styles';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import CommunicatorTicketingUI from './communicator-ticketing-ui/communicator-ticketing-ui';
import { resolveAppTheme } from './communicator-ticketing-ui/utils';
import { CREATE_TICKET_PATH } from './constants/routes';

import './App.css';

const appTheme = resolveAppTheme();

const App = () => {
  return (
    <ThemeProvider theme={appTheme}>
      <BrowserRouter>
        <Routes>
          <Route path={CREATE_TICKET_PATH} element={<CommunicatorTicketingUI />} />
          <Route path="*" element={<Navigate to={CREATE_TICKET_PATH} replace />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
